import { Feature, FeatureKeys } from '@/types'
import { getModule, Module, VuexModule } from 'vuex-module-decorators'
import store from '@/store'
import { growthBookService } from '@/services/growthbookService'

@Module({ dynamic: true, store, name: 'features', namespaced: true })
export default class Features extends VuexModule {
  get featureOn () {
    return (feature: Feature) => {
      return growthBookService.growthBook.getFeatureValue(feature, this.defaultValue(feature))
    }
  }

  get useBubblesCanvas () {
    return this.featureOn(FeatureKeys.USE_BUBBLES_CANVAS)
  }

  get useNLevels () {
    return this.featureOn(FeatureKeys.USE_N_LEVELS)
  }

  get defaultValue () {
    return (feature: Feature) => !this.disabledByDefault.includes(feature)
  }

  get disabledByDefault ():Feature[] {
    return [
      FeatureKeys.USE_BUBBLES_CANVAS,
      FeatureKeys.USE_N_LEVELS,
    ]
  }
}

export const FeaturesModule = getModule(Features)
